import { webappUrl } from "@/environment";

export function appBaseUrl(company) {
  return company ? `${webappUrl}?company=${company}` : webappUrl;
}

export function appUrl(path) {
  return `${webappUrl}#${path}`;
}

export function appBoardUrl(sessionId, editState, query = {}) {
  // Query params go before the hash so they survive pi-web's hash-router navigation.
  const qs = new URLSearchParams(query).toString();
  return `${webappUrl}${qs ? `?${qs}` : ""}#/app/${sessionId}/*/${stateToPath[editState] || "program"}`;
}

const stateToPath = {
  teams: "team",
  teamBoards: "team",
  riskBoard: "risk",
  programBoard: "program",
  programBacklogBoard: "backlog",
  solutionPlanningBoard: "solution",
  solutionBacklogBoard: "solution_backlog",
  flexBoards: "flex",
};
